export default "__VITE_ASSET__tQ9xBdZG__"